export const appVersion = '1.0.3';

// password configuration
export const specialChars = '!@#$%& *()][}{|,:;<>/?+-_=';
export const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export const description = 'Portal e-usług związanych z infrastrukturą drogową Zarządu Dróg Powiatowych w Nowym Mieście Lubawskim';

export const topRightUELogoEnabled = true;

// export const appLogoTopUrl = '/img/Herb_Polski.svg';
// export const appLogoBottomUrl = '/img/icons/godlo-12.svg';

export const appLogoTopUrl = '/img/logo.png';
export const appLogoBottomUrl = '/img/logo-footer.png';

export const showFooterEULogotypes = true;

// application configuration

export const applicationSubmittedTo = 'Zarząd Dróg Powiatowych w Nowym Mieście Lubawskim z/s w Kurzętniku';
